export type CompanyDataColumns = {
    closingDate: number
    name: string
    id: string
    sub: string
    code: string
    autoPayment: string
    contractStatus: ContractStatus
}

export enum ContractStatus {
    active = "active",
    inactive = "inactive"
}

export type CompanyJson = {
    closingDate: number
    name: string
    memberId: string
    sub: string
    code: string
    autoPayment: string
    contractStatus: ContractStatus
}